var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.6719,
    y: 19.3359,
    width: 18,
    height: 52.6667,
    fill: "#FFD600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2918 70.4864L50.0954 3.40615C48.8833 1.27746 46.8357 0 44.6181 0C42.4004 0 40.3525 1.2711 39.1407 3.39979L0.944066 70.474C-0.25958 72.5882 -0.315543 75.0154 0.794934 76.9251C1.90511 78.8348 4.02049 80 6.45319 80H82.7826C85.2153 80 87.3307 78.8348 88.4409 76.9251C89.5514 75.0154 89.4957 72.6005 88.2918 70.4864ZM44.3661 21.4663C47.2897 21.4663 49.6598 23.8364 49.6598 26.76V45.8175C49.6598 48.7412 47.2897 51.1113 44.3661 51.1113C41.4424 51.1113 39.0723 48.7412 39.0723 45.8175V26.76C39.0723 23.8364 41.4424 21.4663 44.3661 21.4663ZM44.6181 57.0935C47.5417 57.0935 49.9118 59.4636 49.9118 62.3872C49.9118 65.3109 47.5417 67.681 44.6181 67.681C41.6944 67.681 39.3243 65.3109 39.3243 62.3872C39.3243 59.4636 41.6944 57.0935 44.6181 57.0935Z",
    fill: "#32373A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.dbc16de511c63d905dfe9eec0a1a39e9.svg";
export { ForwardRef as ReactComponent };